import { handleRequest } from "../utilities/requestHandler";


export const createOrder = (newCheckoutDetails) =>
    handleRequest("post","/orders/create",newCheckoutDetails);

export const validatePromotion = (promotionDetails) =>
    handleRequest("post", "/promotions/validate", promotionDetails);

export const getPromotionAvailability = (params) =>
    handleRequest("get", "/promotions/availability", params);

export const resolveLineDiscounts = (payload) =>
    handleRequest("post", "/line-discounts/resolve", payload);
